export default __webpack_public_path__ + "static/media/Helm of the Howling Giant.2455eeb7.jpg";